const { host } = window.location;

export const isHQDomain = !!host.match(/(hq-(\w+)|hq)\.guesty\.com/);
